import Model from '@ember-data/model';
import type { Type } from '@warp-drive/core-types/symbols';

/**
 * Minimal model for the `custom-user-document-templates` JSONAPI type.
 *
 * The backend (envoy-web) returns this type in the `user-document-template`
 * relationship of `document-upload-requirements`. It is an STI subclass of
 * `UserDocumentTemplate` on the Rails side, but we only need the record's
 * id to call the `confirm-document` endpoint.
 */
export default class CustomUserDocumentTemplate extends Model {
  declare [Type]: 'custom-user-document-template';
}
